<script lang="ts" setup>
import lottie, { type AnimationItem } from 'lottie-web/build/player/lottie_light.js'
import animations from '@/assets/animations'

const props = defineProps<{
  animation: string
}>()

const lottieAnimationContainer = useTemplateRef<HTMLElement>('lottieAnimationContainer')
const animationPlayer = ref<AnimationItem | null>(null)

onMounted(() => {
  if (lottieAnimationContainer.value) {
    const animationData = animations[props.animation]
    animationPlayer.value = lottie.loadAnimation({
      container: lottieAnimationContainer.value,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: animationData.component,
    })
  }
})

onBeforeUnmount(() => {
  if (animationPlayer.value) animationPlayer.value.destroy()
})
</script>

<template>
  <div ref="lottieAnimationContainer"></div>
</template>
